<template>
  <div class="price-card"  @click="goDetail(cardData.id)" >
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
     :src="cardData.cover_mobile || cardData.img_url" alt=""></van-image>
    <div class="price-msg">
      <div class="price-name ellipsis_two">{{ cardData.name }}</div>
      <div class="price-des">{{ cardData.description }}</div>
      
    </div>
    <div class="price-msg2" v-if="!hideStudy">
      <div class="time">{{cardData.ordernum}}人学习 </div>
      <div class="price"  v-if="plat!=120 && type!='live' && !$store.state.plat.priceHide">¥ {{ cardData.price }}</div>
      <div class="btn"  v-if="btnText">{{ btnText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    },
    btnText: {
      type:String,
      default : ''
    },
    hideStudy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      let url = `./detailYingyou?id=${id}`
     
      this.$router.push(url);
    },
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: calc(100% - 60px);
  margin-bottom: 26px;
  margin: 0 30px;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  .tip{
    position: absolute;
    top:0;
    left:30px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 100%;
  border-radius: 12px;
  display: block;
  overflow: hidden;
}

.price-msg {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding: 20px;
}
.price-msg2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px 20px;
  align-items: center;
}
.price-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  padding-top: 10px;
  margin-bottom: 10px;
}

.price-des {
  font-size: 24px;  
  color: #999;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
}

.price {
  font-size: 24px;
  color: #ff4d41;
  font-weight: 600;
}
.btn{
  height: 50px;
  border-radius: 28px;
  line-height: 50px;
  background-color: #f7f7f7;
  color: #144094;
  width: 250px;
  text-align: center;
  font-weight: 500;
}
</style>>
